<template>
    <nio-dropdown class="w-full p-0" max-height-class-name="max-h-full" placement="top">
        <template #trigger>
            <button
                class="w-full flex items-center justify-center text-right | xl:py-2 xl:my-4 xl:text-left | 2xl:px-6 2xl:justify-start"
                v-tooltip="{ content: tooltipContent, placement: 'right', allowHTML: true }"
            >
                <div class="hidden w-7 h-7 flex-shrink-0 | xl:block | 2xl:w-9 2xl:h-9">
                    <img alt="Avatar" class="rounded-full" src="/img/default-person.png">
                </div>
                <div class="flex-1 truncate mr-4 | xl:hidden | 2xl:ml-4 2xl:mr-0 2xl:block">
                    <div class="font-medium truncate" v-text="authUser.fullName" />
                    <div class="text-xs truncate" v-text="authUser.account.name" />
                </div>
                <div class="w-8 h-8 flex-shrink-0 | xl:hidden">
                    <img alt="Avatar" class="rounded-full" src="/img/default-person.png">
                </div>
                <nio-icon class="hidden ml-2 text-xs | 2xl:block" name="regular/arrow-up-1" />
            </button>
        </template>

        <div class="inline-flex items-center mx-4 my-3">
            <div class="w-8 h-8 mr-3">
                <img alt="Avatar" class="rounded-full" src="/img/default-person.png">
            </div>
            <div class="text-base whitespace-no-wrap">
                {{ authUser.fullName }}
            </div>
        </div>

        <template v-if="showAccountOptions">
            <hr class="border-gray-200">
            <nav-account-options class="my-2" />
        </template>

        <template v-if="authUser.account.monthly_segments_limit">
            <hr class="border-gray-200">
            <segments-usage-progress class="p-4" />
        </template>

        <hr class="border-gray-200">

        <div class="flex flex-col my-2">
            <nio-dropdown-item
                class="hidden | xl:flex"
                icon="regular/cog"
                tag="router-link"
                :to="{ name: 'configs.user.profile' }"
            >
                {{ $t('global.general.settings') }}
            </nio-dropdown-item>
            <nio-dropdown-item
                :href="supportLink"
                icon="regular/question-circle"
                tag="a"
                target="_blank"
            >
                {{ $t('global.general.help') }}
            </nio-dropdown-item>
            <nio-dropdown-item
                class="hover:text-red-500"
                icon="regular/power-button"
                @click="logout"
            >
                {{ $t('global.general.logout') }}
            </nio-dropdown-item>
        </div>
    </nio-dropdown>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import NavAccountOptions from '@/components/Navs/NavAccountOptions.vue';
    import SegmentsUsageProgress from '@/components/SegmentsUsageProgress.vue';

    export default {
        components: {
            NavAccountOptions,
            SegmentsUsageProgress,
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            showAccountOptions() {
                return this.authUser.accounts && this.authUser.accounts.length > 1;
            },

            supportLink() {
                if (this.$i18n.locale == 'en') {
                    return 'https://www.activix.ca/en/contact-us';
                }

                return 'https://www.activix.ca/fr/nous-joindre';
            },

            tooltipContent() {
                if (this.$mq !== 'xl') {
                    return '';
                }

                return `
                    <div class="text-left">
                        <div class="font-medium">${this.authUser.fullName}</div>
                        <div class="text-xs">${this.authUser.account.name}</div>
                    </div>
                `;
            },
        },

        methods: {
            ...mapActions([
                'clearAuthUser',
            ]),

            logout() {
                this.clearAuthUser();
            },
        },
    };
</script>
